export function getTitleSizeClass(title: string): string {
  const length = title.length;

  if (length <= 50) return 'text-4.5xl';
  if (length <= 90) return 'text-3xl';
  if (length <= 170) return 'text-2xl';
  if (length <= 280) return 'text-xl';
  if (length <= 350) return 'text-lg';

  return 'text-base';
}
